import React from "react";
import { ShieldCheck, Clock } from "lucide-react";
import { useAuth } from "@/lib/auth";
import IdentityVerify from "@/components/IdentityVerify";

export const SENDER_VERIFY_MSG = "Verify your identity to send your first parcel. Travellers are carrying your parcel in person, so we verify everyone on both sides.";

// Sender-side identity check. Approval (not just an upload) is needed before contacting carriers or paying.
export const SenderVerifyCard = ({ need = "contact" }) => {
  const { user } = useAuth();
  const sv = user?.sender_verification;
  if (!sv || (need === "contact" ? sv.can_contact : sv.can_pay)) return null;
  if (sv.status === "pending") {
    return (
      <div className="rounded-2xl border border-sky-200 bg-sky-50 p-4 text-sm text-sky-900 flex gap-2" data-testid="sender-verify-pending">
        <Clock className="w-4 h-4 shrink-0 mt-0.5"/>
        <div><b>Your ID is under review.</b> {need === "pay" ? "Payment unlocks" : "You can send requests"} as soon as it's approved.</div>
      </div>
    );
  }
  return (
    <div className="rounded-2xl border border-sky-200 bg-sky-50 p-4 text-sm text-sky-900" data-testid="sender-verify-card">
      <div className="flex gap-2">
        <ShieldCheck className="w-4 h-4 shrink-0 mt-0.5"/>
        <div className="flex-1">
          <div className="font-semibold">Verify your identity</div>
          <div className="mt-0.5 mb-3" data-testid="sender-verify-msg">{SENDER_VERIFY_MSG}</div>
          <IdentityVerify/>
        </div>
      </div>
    </div>
  );
};
